import * as React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { NUMBER_ZERO } from '@mitchell/react.component.ux';
import { getQuestionnaireEvaluationAnswerList, getQuestionnaireEvaluationParentQuestionId, getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestionnaireQuestionId } from "../../questionnaireEvaluation";
import { onVehicleInfoUpdated } from "../../vehicleInfo";
import { getVehicleConfigurationAttributesRequestAction } from "../../vehicleConfigurationAttributes";
import { photoCaptureIntelligentViewChangeAction, photoCaptureIntelligentClickNextQuestionAction, photoCaptureIsFileUploadStartedAction, photoCaptureFileUploadFailedAction, photoCaptureIntelligentResetSaveCapturedPhotoAction } from '../actions';
import { IntelligantPhotoCaptureAddCommentView } from '../components';
import { PhotoCaptureAttributeType } from '../enums';
import { getCapturedUploadPhotoFiles, getIntelligentPhotoCapturePRGMiscDetails, getIntelligentPhotoCaptureLastRenderedView, getIntelligentSequenceScreenName, getPhotoCaptureAttachmentInfo, getPhotoCaptureCompanyCode, getPhotoCaptureCountryCode, getPhotoCaptureDisableLibrary, getPhotoCaptureFileSizeLimit, getPhotoCaptureImageMaxWidth, getShouldAllowMitchellIntelligent, getShouldNewImageUploaded, getShouldShowCommentBox, getIntelligentPhotoOCRInfo, getShouldEnableOCRImageTextDecode, getIntelligentPhotoCaptureImageDetail, getShouldEnableImageQualityAssessment, getShouldEnableAdditionalOption, getFoldersOptionList } from '../selectors';
const mapStateToProps = (state, ownProps) => ({
    questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
    sequenceScreenName: getIntelligentSequenceScreenName(state),
    shouldShowCommentBox: getShouldShowCommentBox(state),
    questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
    photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
    parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
    files: getCapturedUploadPhotoFiles(state),
    companyCode: getPhotoCaptureCompanyCode(state),
    fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
    imageMaxWidth: getPhotoCaptureImageMaxWidth(state),
    disableLibrary: getPhotoCaptureDisableLibrary(state),
    isMic: getShouldAllowMitchellIntelligent(state),
    prgMiscImage: getIntelligentPhotoCapturePRGMiscDetails(state),
    lastRenderedView: getIntelligentPhotoCaptureLastRenderedView(state),
    shouldNewImageUploaded: getShouldNewImageUploaded(state),
    countryCode: getPhotoCaptureCountryCode(state),
    ocrText: getIntelligentPhotoOCRInfo(state).ocrText,
    shouldEnableOCRImageTextDecode: getShouldEnableOCRImageTextDecode(state),
    shouldEnableImageQualityAssessment: getShouldEnableImageQualityAssessment(state),
    iqaScores: getIntelligentPhotoCaptureImageDetail(state),
    shouldEnableAdditionalOption: getShouldEnableAdditionalOption(state),
    folderOptionList: getFoldersOptionList(state),
    answerList: getQuestionnaireEvaluationAnswerList(state)
});
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    },
    onNextQuestionClick: (questionSubType) => {
        dispatch(photoCaptureIntelligentClickNextQuestionAction(true));
    },
    onFileUploadFailed: () => {
        dispatch(photoCaptureIsFileUploadStartedAction(false));
        dispatch(photoCaptureFileUploadFailedAction());
    },
    onResetUploadedImage: () => dispatch(photoCaptureIntelligentResetSaveCapturedPhotoAction()),
    onVehicleInfoUpdated: (vehicleInfo) => dispatch(onVehicleInfoUpdated(vehicleInfo)),
    loadVehicleConfigurationAttributes: ({ vehicleId, dateOfLoss }) => dispatch(getVehicleConfigurationAttributesRequestAction({ vehicleId, dateOfLoss }))
});
const IntelligentPhotoCaptureAddCommentViewWrapper = (props) => {
    const { questionSubType, answerList, loadVehicleConfigurationAttributes, onVehicleInfoUpdated } = props;
    React.useEffect(() => {
        if (questionSubType === PhotoCaptureAttributeType.VIN_CAPTURE) {
            const vehicleVinDataLocal = answerList && answerList[0].answerDisplayText && JSON.parse(answerList[0].answerDisplayText)[0].vehicleVinData;
            vehicleVinDataLocal && onVehicleInfoUpdated && onVehicleInfoUpdated(vehicleVinDataLocal);
            get(vehicleVinDataLocal, 'Vehicle') &&
                loadVehicleConfigurationAttributes &&
                loadVehicleConfigurationAttributes({ vehicleId: get(vehicleVinDataLocal, 'Vehicle.Id', NUMBER_ZERO) });
        }
    }, [answerList, questionSubType]);
    return React.createElement(IntelligantPhotoCaptureAddCommentView, Object.assign({}, props));
};
export const IntelligentConnectedPhotoCaptureAddCommentView = connect(mapStateToProps, mapDispatchToProps)(IntelligentPhotoCaptureAddCommentViewWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureAddCommentView.js.map